import { useState } from "react";
import { FilterTab } from "../../../components/Filters";
import { Consumption } from "./Consumption";
import { Production } from "./Production";
import { GasImport } from "./Import";
import "./Gas.css";
import { PowerStationAnalysis } from "./PowerStationAnalysis";
import { PowerStationByDate } from "./PowerStation";
import { ConsumptionProduction } from "./ConsumptionProduction";

const TABS = [
  "Consumption",
  "Production",
  "Import",
  "Consumption vs Production",
  // "Import vs Production",
  "Power Station Snapshot",
  "Power Station Analysis",
];
export function GasPage() {
  const [tab, setTab] = useState(TABS[0]);
  return (
    <div className="h-full w-full">
      <div className="header">
        <h1>Gas</h1>
        <div className="gas-tabs">
          <FilterTab
            isSingle={true}
            options={TABS}
            selected={[tab]}
            onClick={setTab}
          />
        </div>
      </div>

      <div className="h-full">
        {tab === "Consumption" && <Consumption />}

        {tab === "Production" && <Production />}
        {tab === "Import" && <GasImport />}
        {tab === "Consumption vs Production" && <ConsumptionProduction />}
        {/* {tab === "Import vs Production" && <ImportProduction />} */}
        {tab === "Power Station Snapshot" && <PowerStationAnalysis />}
        {tab === "Power Station Analysis" && <PowerStationByDate />}
      </div>
    </div>
  );
}
